/* eslint-disable no-param-reassign */
const isEmpty = (val) => (val || '').trim().length === 0

export function assign(a, b) {
	return [...Array(Math.max(a.length, b.length))]
		.map((v, i) => b[i] || a[i])
}

export function balance(length, target) {
	if (target.length > length) {
		target.splice(length)
	}
	if (target.length < length) {
		for (let i = 0; i < length; i++) {
			if (!target[i]) target[i] = ''
		}
	}
}

export function trimTail(arr, min = 2) {
	for (let i = arr.length - 1; i >= min; i--) {
		if (isEmpty(arr[i])) {
			arr.pop()
		} else {
			break
		}
	}
	return arr
}



// WEBPACK FOOTER //
// ./src/lib/array.js